//  frontend/src/components/support/PaymentSummary.js
export default function PaymentSummary({ packageData, tip }) {
  const total = Number(packageData.price) + Number(tip);

  return (
    <div
      style={{
        background: "rgba(255,255,255,0.05)",

        padding: 24,

        borderRadius: 20,

        marginBottom: 30,
      }}
    >
      <h2>{packageData.name}</h2>

      <div>Package: ${packageData.price}</div>

      <div>Tip: ${tip}</div>

      <div
        style={{
          marginTop: 16,
          fontSize: 32,
          color: "#ffb100",
        }}
      >
        Total: ${total.toFixed(2)}
      </div>
    </div>
  );
}
